(function () {
  "use strict";

  var ADDRESS_KEYS = ["selectedAddress", "certnz_address"];
  var TITLE_KEYS = ["selectedTitleRef", "certnz_titleRef"];

  window.__certnzProductAddonsLoaded = true;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getInput(id) {
    return document.getElementById(id);
  }

  function remember(keys, value) {
    if (!value) return;
    keys.forEach(function (key) {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        // Some Shopify preview/sandbox contexts block localStorage.
      }
    });
  }

  function getSelectedAddOns() {
    return Array.prototype.slice.call(document.querySelectorAll(".certnz-addon-checkbox:checked"))
      .map(function (input) {
        return {
          id: parseInt(input.getAttribute("data-variant-id"), 10),
          title: input.getAttribute("data-title") || "Add-on document"
        };
      })
      .filter(function (addon) {
        return addon.id;
      });
  }

  function showValidation(message) {
    var validation = document.getElementById("validation-msg");
    if (validation) {
      validation.textContent = message;
      validation.style.display = "block";
    } else {
      alert(message);
    }
  }

  function hideValidation() {
    var validation = document.getElementById("validation-msg");
    if (validation) validation.style.display = "none";
  }

  function buildItems(address, titleRef) {
    var root = document.getElementById("certnz-addons");
    var mainVariantId = root ? parseInt(root.getAttribute("data-main-variant-id"), 10) : 0;
    var productTitle = root ? root.getAttribute("data-product-title") || "" : "";
    var properties = {};

    if (!mainVariantId) {
      throw new Error("The product could not be added. Please refresh the page and try again.");
    }

    if (address) properties["Property Address"] = address;
    if (titleRef) properties["Title Reference"] = titleRef;

    var qty = 1;
    var qtyInput = getInput("product-instruments-quantity");
    if (qtyInput) {
      qty = parseInt(qtyInput.value, 10) || 1;
      properties["Instruments Quantity"] = String(qty);
    }

    var items = [{
      id: mainVariantId,
      quantity: qty,
      properties: properties
    }];

    getSelectedAddOns().forEach(function (addon) {
      var addonProperties = {};
      if (address) addonProperties["Property Address"] = address;
      if (titleRef) addonProperties["Title Reference"] = titleRef;
      addonProperties["Add-on for"] = productTitle;

      items.push({
        id: addon.id,
        quantity: 1,
        properties: addonProperties
      });
    });

    return items;
  }

  function wireBuyButton() {
    window.__certnzProductAddonsWireAttempts = (window.__certnzProductAddonsWireAttempts || 0) + 1;

    var btn = document.getElementById("buy-now-button");
    if (!btn || btn.__certnzAddonWired) return;

    btn.setAttribute("type", "button");
    btn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var addressInput = getInput("product-address-input");
      var titleInput = getInput("product-title-reference-input");
      var address = addressInput ? addressInput.value.trim() : "";
      var titleRef = titleInput ? titleInput.value.trim() : "";

      if (!address && !titleRef) {
        showValidation("Please enter at least a Property Address or Title Reference.");
        if (addressInput) addressInput.focus();
        return;
      }

      hideValidation();
      remember(ADDRESS_KEYS, address);
      remember(TITLE_KEYS, titleRef);

      var originalText = btn.textContent;
      btn.disabled = true;

      try {
        var items = buildItems(address, titleRef);
        btn.textContent = items.length > 1 ? "Adding " + items.length + " items..." : "Adding...";

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || (result.data && result.data.status === 422)) {
              throw new Error((result.data && (result.data.description || result.data.message)) || "Error adding to cart");
            }
            return fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ attributes: { "Property Address": address, "Title Reference": titleRef } })
            });
          })
          .then(function () {
            window.location.href = "/cart";
          })
          .catch(function (error) {
            console.error("Error adding to cart:", error);
            btn.disabled = false;
            btn.textContent = originalText || "Buy Now";
            showValidation(error && error.message ? error.message : "Something went wrong. Please try again.");
          });
      } catch (error) {
        btn.disabled = false;
        btn.textContent = originalText || "Buy Now";
        showValidation(error && error.message ? error.message : "Something went wrong. Please try again.");
      }
    }, true);

    btn.__certnzAddonWired = true;
  }

  window.certnzProductAddonsWire = wireBuyButton;
  ready(wireBuyButton);
  window.addEventListener("load", wireBuyButton);
})();
